const stateSpecificSurcharges = {
    PersonalAuto_EA:{
        NH: [
            "EA_FinancialFilingFee"
        ]
    } 
}

export default stateSpecificSurcharges;